import { React, useState, useEffect } from "react";
import "../Faq/faq.scss";
export const Faqs = () => {
  // State to manage which FAQ is open
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    // console.log(index, activeIndex);
    // If the clicked item is already open, close it. Otherwise, open it.
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Array of FAQ questions and answers
  const faqs = [
    {
      question:
        "Who is eligible to participate in the Predict and Win Contest?",
      answer: [
        {
          keyPoint: "All subscribers who are currently not active on any plan.",
        },
        {
          keyPoint:
            "Users who have registered on Watcho, but have never subscribed to a Watcho plan.",
        },
      ],
    },
    {
      question: "How long are the coupons valid?",
      answer:
        "Coupons are valid till six months after the Champions Trophy 2025 ends (i.e. till 9th Sep 2025).",
    },
    {
      question: "How can I redeem my coupons?",
      answer:
        "To redeem a coupon - Log-in to the Watcho website or app, navigate to the ‘Plans and Offers’ page, select your desired plan, enter your coupon code in the ‘Add a Coupon’ section at checkout.",
    },
    {
      question: "Can I use multiple coupons at once?",
      answer: "No, only one coupon can be applied per transaction.",
    },
    {
      question: "Can I share my coupon with friends or family?",
      answer: "Yes, the coupon can be gifted to your friends and family.",
    },
    {
      question: "Can I participate in the contest multiple times?",
      answer:
        "A user can enter the contest only once per match using their mobile number. However, they are welcome to participate in every India match.",
    },
  ];

  useEffect(() => {}, [activeIndex]);

  return (
    <>
      <div className="iplContestFaqContainer" id="faqs">
        <h1 className="text-center">FAQ’s</h1>
        <div className="container mt-5">
          {/* {faqs.map((faq, index) => (
                        <div key={index} className={`iplContestFaq-item ${openIndex === index ? 'active' : ''}`}>
                            <div className="iplContestFaq-question" onClick={() => handleToggle(index)}>
                                <span>{faq.question}</span>
                                <i className="fas fa-chevron-down"></i>
                            </div>
                            {openIndex === index && (
                                <div className="iplContestFaq-answer">
                                    {typeof faq.answer == "string" ? (<p>{faq.answer}</p>) : (<ul className="bulletPoints">
                                        {faq.answer.map((item, index) => (
                                            <li key={index}>{item.keyPoint}</li>
                                        ))}
                                    </ul>)}
                                </div>
                            )}
                        </div>
                    ))} */}

          <div className="accordion" id="faqAccordion">
            {/* Accordion Item 1 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingOne">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(0)}
                  aria-expanded={activeIndex === 0}
                  aria-controls="faqAccordionCollapseOne"
                  style={{ cursor: "pointer" }}
                >
                  Who is eligible to participate in the Predict and Win Contest?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseOne"
                className={`collapse ${activeIndex === 0 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingOne"
              >
                <div className="card-body">
                  Users who have registered on the Watcho App or web and have
                  received the link to participate.
                </div>
              </div>
            </div>

            {/* Accordion Item 2 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingTwo">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(1)}
                  aria-expanded={activeIndex === 1}
                  aria-controls="faqAccordionCollapseTwo"
                  style={{ cursor: "pointer" }}
                >
                  How many questions will be posted every day?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseTwo"
                className={`collapse ${activeIndex === 1 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingTwo"
              >
                <div className="card-body">
                  There will only be 1 question posted every day and the day
                  when there are two matches in a day then both the questions
                  for their respective matches will be posted.
                </div>
              </div>
            </div>

            {/* Accordion Item 3 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingThree">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(2)}
                  aria-expanded={activeIndex === 2}
                  aria-controls="faqAccordionCollapseThree"
                  style={{ cursor: "pointer" }}
                >
                  What is the time for the question to go Live.
                </h2>
              </div>

              <div
                id="faqAccordionCollapseThree"
                className={`collapse ${activeIndex === 2 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingThree"
              >
                <div className="card-body">
                  The question will be Live at 12.30 am on the day of the match
                  and will be open till half an hour before the match starts,
                  post which contest for that day shall end.
                </div>
              </div>
            </div>

            {/* Accordion Item 4 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingFour">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(3)}
                  aria-expanded={activeIndex === 3}
                  aria-controls="faqAccordionCollapseFour"
                  style={{ cursor: "pointer" }}
                >
                  What will I get for participation?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseFour"
                className={`collapse ${activeIndex === 3 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingFour"
              >
                <div className="card-body">
                  <p className="mb-2">
                    The user will get a discount coupon worth Rs 150 of Watcho
                    on participation and will be given points basis his/her
                    response as mentioned below:
                  </p>
                  <ul className="bulletPoints">
                    <li>
                      <strong>Every Participation :</strong> 1 Point
                    </li>
                    <li>
                      <strong>Every Right Answer :</strong> 5 Points
                    </li>
                    <li>
                      <strong>Every Watcho Coupon Redemption :</strong> 10
                      Points
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Accordion Item 5 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingFive">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(4)}
                  aria-expanded={activeIndex === 4}
                  aria-controls="faqAccordionCollapseFive"
                  style={{ cursor: "pointer" }}
                >
                  Can I share my Watcho coupon with friends or family?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseFive"
                className={`collapse ${activeIndex === 4 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingFive"
              >
                <div className="card-body">
                  Yes, you can share it with friends and family , however the
                  coupon is linked to your registered mobile number and in case
                  it is redeemed the points will be credited to your leader
                  board.
                </div>
              </div>
            </div>

            {/* Accordion Item 6 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingSix">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(5)}
                  aria-expanded={activeIndex === 5}
                  aria-controls="faqAccordionCollapseSix"
                  style={{ cursor: "pointer" }}
                >
                  Which all are the redemption coupons?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseSix"
                className={`collapse ${activeIndex === 5 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingSix"
              >
                <div className="card-body">
                  <p className="mb-2">
                    The Watcho coupons will be given on every participation.
                    Every correct answer will make a user eligible to be a part
                    of the leader board and EaseMyTrip coupon will be given to
                    25 winners weekly basis the leader board.{" "}
                  </p>
                  <ol className="numbering">
                    <li>
                      <strong>Weekly Winners :</strong> Top 25 users on the
                      leader board will win Ease My Trip Voucher worth Rs
                      1500.T&C Apply.
                    </li>
                    <li>
                      <strong>The bumper winner will be –</strong> Top 3 from
                      the leader board on completion of the contest and will win
                      2 tickets each to the one of the qualifiers.
                    </li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Accordion Item 7 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingSeven">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(6)}
                  aria-expanded={activeIndex === 6}
                  aria-controls="faqAccordionCollapseSeven"
                  style={{ cursor: "pointer" }}
                >
                  How long are the coupons valid?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseSeven"
                className={`collapse ${activeIndex === 6 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingSeven"
              >
                <div className="card-body">
                  Watcho Coupons are valid till six months after the tournament
                  ends & EaseMyTrip coupons are valid till 30th June’25.
                </div>
              </div>
            </div>

            {/* Accordion Item 8 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingEight">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(7)}
                  aria-expanded={activeIndex === 7}
                  aria-controls="faqAccordionCollapseEight"
                  style={{ cursor: "pointer" }}
                >
                  How can I redeem my coupons?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseEight"
                className={`collapse ${activeIndex === 7 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingEight"
              >
                <div className="card-body">
                  <ol>
                    <li>
                      <strong>Watcho Coupons :</strong> To redeem a coupon -
                      Log-in to the Watcho website or app, navigate to the{" "}
                      <strong>
                        <em>Plans and Offers</em>
                      </strong>{" "}
                      page, select your desired plan, enter your coupon code in
                      the{" "}
                      <strong>
                        <em>Add a Coupon</em>
                      </strong>{" "}
                      section at checkout
                    </li>
                    <li>
                      <strong>Ease My Trip Coupons :</strong>{" "}
                      <u>INR 1500 OFF on Flights</u> :
                    </li>
                    <ul className="bulletPoints">
                      <li>No minimum booking conditions</li>
                      <li>Valid till 30th June 2025</li>
                      <li>
                        User will get INR 500 OFF on 1 pax, INR 1000 OFF on 2
                        pax and INR 1500 OFF on 3 pax bookings
                      </li>
                      <li>Valid for both new and repeat users</li>
                      <li>
                        Valid on all platforms (desktop, msite, ios and android
                        apps)
                      </li>
                      <li>Offer is valid once per user</li>
                      <li>Offer is valid only for flights vertical</li>
                    </ul>
                  </ol>
                  <p className="mt-2">
                    URL:{" "}
                    <a
                      href="https://www.easemytrip.com/?utm_source=watcho_alliance&utm_medium=partnership"
                      target="_blank"
                    >
                      https://www.easemytrip.com/?utm_source=watcho_alliance&utm_medium=partnership
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Accordion Item 9 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingNine">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(8)}
                  aria-expanded={activeIndex === 8}
                  aria-controls="faqAccordionCollapseNine"
                  style={{ cursor: "pointer" }}
                >
                  Can I use multiple coupons at once?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseNine"
                className={`collapse ${activeIndex === 8 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingThree"
              >
                <div className="card-body">
                  No, only one coupon can be applied per transaction.
                </div>
              </div>
            </div>

            {/* Accordion Item 10 */}
            <div className="card">
              <div className="card-header" id="faqAccordionHeadingTen">
                <h2
                  className="mb-0"
                  onClick={() => toggleAccordion(9)}
                  aria-expanded={activeIndex === 9}
                  aria-controls="faqAccordionCollapseTen"
                  style={{ cursor: "pointer" }}
                >
                  Can I participate in the contest multiple times?
                </h2>
              </div>

              <div
                id="faqAccordionCollapseTen"
                className={`collapse ${activeIndex === 9 ? "show" : ""}`}
                aria-labelledby="faqAccordionHeadingThree"
              >
                <div className="card-body">
                  A user can enter the contest only once per match using their
                  mobile number. However, they are welcome to participate in
                  every match.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
